import LearningManagerStore from 'Stores/LearningManagerStore';
import AssignUsersStore from 'Stores/AssignUsersStore';
import { ASSIGN_USERS_OPTION } from 'LearningManager/constants/createAssignment.constant';
import { AudienceSelection, EMPTY_AUDIENCE } from './AssignmentAudiencePicker';

const methodIdForGroupLabel = (label?: string): number => {
	if (label === 'Organization') return ASSIGN_USERS_OPTION.ORGANIZATION;
	if (label === 'Property') return ASSIGN_USERS_OPTION.PROPERTY;
	return ASSIGN_USERS_OPTION.GROUP;
};

export const resolveAssignmentAudience = async (
	learningManagerStore: LearningManagerStore,
	assignUsersStore: AssignUsersStore,
	assignmentId: number,
	scopes: string[],
	tenantId?: number
): Promise<AudienceSelection> => {
	if (scopes.includes('roles')) {
		const roles = await learningManagerStore.getAssignmentSourceScopeRoles(
			assignmentId
		);
		return {
			...EMPTY_AUDIENCE,
			methodId: ASSIGN_USERS_OPTION.ROLE,
			entityIds: roles.map((r) => Number(r.id))
		};
	}

	if (scopes.includes('users')) {
		const users = await learningManagerStore.getAssignmentSourceScopeUsers(
			assignmentId
		);
		return {
			...EMPTY_AUDIENCE,
			methodId: ASSIGN_USERS_OPTION.INDIVIDUAL,
			userIds: users.map((u) => u.id)
		};
	}

	if (scopes.includes('groups')) {
		const scopeGroups = await learningManagerStore.getAssignmentSourceScopeGroups(
			assignmentId
		);
		const groupIds = scopeGroups.map((g) => Number(g.id));
		const groups = await assignUsersStore
			.fetchGroupsByIds(groupIds)
			.catch(() => []);
		const labels = [...new Set(groups.map((g) => g.label))];
		const methodId = methodIdForGroupLabel(
			labels.length === 1 ? labels[0] : undefined
		);
		return {
			...EMPTY_AUDIENCE,
			methodId,
			entityIds: groupIds,
			groupPropertyIds:
				methodId === ASSIGN_USERS_OPTION.GROUP
					? [...new Set(groups.map((g) => g.parentId))]
					: []
		};
	}

	if (scopes.includes('group_labels') && tenantId !== undefined) {
		const labels = await learningManagerStore.getAssignmentSourceScopeGroupLabels(
			assignmentId
		);
		if (labels.some((l) => l.group_id === 'Organization')) {
			return {
				...EMPTY_AUDIENCE,
				methodId: ASSIGN_USERS_OPTION.ORGANIZATION,
				entityIds: [tenantId]
			};
		}
	}

	return EMPTY_AUDIENCE;
};
